export const noop = (...args: any[]): any => {};
export const asyncNoop = async (...args: any[]): Promise<any> => undefined;
